import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
  ActiveSign,
  AgentName,
  Avatar,
  ContactNumber,
  CustomTabs,
  Group,
  KeypadOption,
  ProfileBar,
  Sign,
  TabItemsCallStyle,
  Title,
  UserList
} from '../styles/dialpadstyle';

import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';
import { Tab, Tabs } from 'react-bootstrap';

export class AddCallTheme extends Component {

  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderList(params) {
    const { image, status, name, info } = params;
    const { onTransfer } = this.props;
    return (
      <ProfileBar style={{ padding: '0px', marginBottom: '10px' }}>
        <Avatar>
          <img src={image} />
          <ActiveSign><Sign className={status} /></ActiveSign>
        </Avatar>
        <AgentName style={{ color: '#303030' }}>{name}<ContactNumber>{info}</ContactNumber></AgentName>
        <Button
          btnStyle="link"
          type="simple"
          onClick={() => {
            onTransfer(params)
          }}
          style={{ marginLeft: 'auto', paddingRight: '0px' }}
        >
          <img src={"images/add-member.svg"} />
        </Button>
      </ProfileBar>
    )
  }

  render() {
    const { title, list } = this.props;
    return (
      <span>
        <CustomTabs>
          <Tabs
            defaultActiveKey="agent"
            id="uncontrolled-tab-example"
            className="customTabs"
          >


            <Title>
              {title}
            </Title>

            {/* <UserList>
              {
                list.map((data) => {
                  return this.renderList(data);
                })
              }
            </UserList> */}

            <Tab eventKey="agent" title="Agent">
              <TabItemsCallStyle>
                <UserList>
                  {
                    list.map((data) => {
                      return this.renderList(data);
                    })
                  }
                </UserList>
              </TabItemsCallStyle>
            </Tab>
            <Tab eventKey="team" title="Team">
              <TabItemsCallStyle>
                <UserList>

                </UserList>
              </TabItemsCallStyle>
            </Tab>
            <Tab eventKey="phoneno" title="Phone No">
              <TabItemsCallStyle>
                <UserList>

                </UserList>
              </TabItemsCallStyle>
            </Tab>
          </Tabs>
        </CustomTabs>



      </span>
    )
  }
}

AddCallTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

AddCallTheme.contextTypes = {
  __: PropTypes.func
};

export default AddCallTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/AddCallTheme.js